import { makeAutoObservable } from "mobx";
import {
    deleteICDCodeMedicationRequestForm,
    getICDCodeMedicationRequestFormById,
    saveOrUpdate,
    pagingICDCodeMedicationRequestForm,
    getAllICDCodeMedicationRequestForms,
    getListMediReqByListICD
} from 'app/services/ICDCodeMedicationRequestFormService';

import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { ICDCodeMedicationRequestForm } from "app/common/Model/ICDCodeMedicationRequestForm";
import { checkSearchObject } from "app/common/LocalFunction";

export default class ICDCodeMedicationRequestFormStore {
    listAllICDCodeMedicationRequestForm = [];
    searchICDCodeMedicationRequestForm = new SearchObject();
    pageICDCodeMedicationRequestForm = null;
    selectedICDCodeMedicationRequestForm = null;
    openFormCreateOrEdit = false;
    openConfirmDelete = false;
    recentlyUpdated = false;
    listMediReqByListICD = []

    constructor() {
        makeAutoObservable(this);
    }

    getListMediReqByListICD = async ({diagnosisDto, concepts}) => {
        try {
            const res = await getListMediReqByListICD(diagnosisDto || concepts)
            this.listMediReqByListICD = res.data
            // console.log(res.data);
        } catch (error) {
            toast.error("Lấy dữ liệu thất bại!")
        }
    }

    getAllICDCodeMedicationRequestForms = async () => {
        return await getAllICDCodeMedicationRequestForms()
            .then(({ data }) => {
                this.listAllICDCodeMedicationRequestForm = data || [];
            })
            .catch(error => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi", "Thông báo");
            })
    }
    pagingICDCodeMedicationRequestForm = async () => {
        return await pagingICDCodeMedicationRequestForm(this.searchICDCodeMedicationRequestForm)
            .then(({ data }) => {
                this.pageICDCodeMedicationRequestForm = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi", "Thông báo")
            })
    }

    handleChangeFormSearch = (searchICDCodeMedicationRequestForm) => {
        this.searchICDCodeMedicationRequestForm = checkSearchObject(this.searchICDCodeMedicationRequestForm, searchICDCodeMedicationRequestForm);
        this.pagingICDCodeMedicationRequestForm();
    }

    handleOpenFormCreateOrEdit = (iCDCodeMedicationRequestFormId) => {
        if (Boolean(iCDCodeMedicationRequestFormId)) {
            getICDCodeMedicationRequestFormById(iCDCodeMedicationRequestFormId).then(({ data }) => {
                this.selectedICDCodeMedicationRequestForm = data;
                this.openFormCreateOrEdit = true;
            })
        } else {
            this.selectedICDCodeMedicationRequestForm = new ICDCodeMedicationRequestForm();
            this.openFormCreateOrEdit = true;
        }
    }

    saveOrUpdateICDCodeMedicationRequestForm = (iCDCodeMedicationRequestForm, { setSubmitting }) => {
        saveOrUpdate(iCDCodeMedicationRequestForm)
            .then(() => {
                this.selectedICDCodeMedicationRequestForm = null;
                toast.success("Lưu dữ liệu thành công!");
                this.handleClosePopup();
                this.pagingICDCodeMedicationRequestForm();
                this.recentlyUpdated = true;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lưu dữ liệu có lỗi");
            })
            .finally(() => setSubmitting(false))
    }

    handleDelete = (iCDCodeMedicationRequestForm) => {
        this.selectedICDCodeMedicationRequestForm = { id: iCDCodeMedicationRequestForm?.id };
        this.openConfirmDelete = true;
    }

    handleConfirmDelete = async () => {
        return await deleteICDCodeMedicationRequestForm(this.selectedICDCodeMedicationRequestForm?.id)
            .then(() => {
                if (this.searchICDCodeMedicationRequestForm?.pageIndex > 1 && this.pageICDCodeMedicationRequestForm?.content?.length === 1) {
                    this.searchICDCodeMedicationRequestForm.pageIndex -= 1;
                }
                toast.success("Xóa bản ghi thành công!");
                this.handleClosePopup();
                this.pagingICDCodeMedicationRequestForm();
                this.recentlyUpdated = true;
            })
            .catch(err => {
                console.error(err);
                toast.error("Xóa bản ghi có lỗi", "Thông báo");
            })
    }

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }

    resetStore = () => {
        this.searchICDCodeMedicationRequestForm = new SearchObject();
        this.pageICDCodeMedicationRequestForm = null;
        this.selectedICDCodeMedicationRequestForm = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
        this.listMediReqByListICD = []
    }

    //for choosing iCDCodeMedicationRequestForm in ChooseICDCodeMedicationRequestFormPopup.jsx 
    listICDCodeMedicationRequestForm = [];
    iCDCodeMedicationRequestFormIdSet = null;

    isValidICDCodeMedicationRequestForm = iCDCodeMedicationRequestForm => {
        if (iCDCodeMedicationRequestForm && iCDCodeMedicationRequestForm?.id) return true;
        console.error("Invalid manipulated element");
        return false;
    }

    addICDCodeMedicationRequestForm = iCDCodeMedicationRequestForm => {
        if (!this.isValidICDCodeMedicationRequestForm(iCDCodeMedicationRequestForm)) return;
        this.listICDCodeMedicationRequestForm.push(iCDCodeMedicationRequestForm);
        this.iCDCodeMedicationRequestFormIdSet.add(iCDCodeMedicationRequestForm?.id);
    }

    initializelistICDCodeMedicationRequestForm = iCDCodeMedicationRequestForms => {
        this.iCDCodeMedicationRequestFormIdSet = new Set();
        this.listICDCodeMedicationRequestForm = [];
        if (iCDCodeMedicationRequestForms && iCDCodeMedicationRequestForms?.length > 0) {
            for (let i = 0; i < iCDCodeMedicationRequestForms.length; i++) {
                this.addICDCodeMedicationRequestForm(iCDCodeMedicationRequestForms[i]);
            }
        }
    }

    removeICDCodeMedicationRequestForm = iCDCodeMedicationRequestForm => {
        if (!this.isValidICDCodeMedicationRequestForm(iCDCodeMedicationRequestForm)) return;
        if (this.iCDCodeMedicationRequestFormIdSet.has(iCDCodeMedicationRequestForm?.id)) {
            this.iCDCodeMedicationRequestFormIdSet.delete(iCDCodeMedicationRequestForm?.id);
        }
        else {
            console.error("Element is not exist");
        }
    }

    isExist = iCDCodeMedicationRequestForm => {
        if (!this.isValidICDCodeMedicationRequestForm(iCDCodeMedicationRequestForm)) return;
        return this.iCDCodeMedicationRequestFormIdSet.has(iCDCodeMedicationRequestForm?.id);
    }

    getICDCodeMedicationRequestFormIdSet = () => {
        return this.iCDCodeMedicationRequestFormIdSet;
    }

    getListICDCodeMedicationRequestForm = () => {
        const bufferIdSet = new Set();
        const data = [];
        if (this.listICDCodeMedicationRequestForm && this.listICDCodeMedicationRequestForm?.length > 0) {
            for (let i = 0; i < this.listICDCodeMedicationRequestForm.length; i++) {
                const iCDCodeMedicationRequestForm = this.listICDCodeMedicationRequestForm[i];
                if (this.isExist(iCDCodeMedicationRequestForm) && !bufferIdSet.has(iCDCodeMedicationRequestForm?.id)) {
                    data.push(iCDCodeMedicationRequestForm);
                    bufferIdSet.add(iCDCodeMedicationRequestForm?.id);
                }
            }
        }
        this.listICDCodeMedicationRequestForm = data;
        return data;
    }

}
